module.exports = __webpack_public_path__ + "media/images/logo-netsuite-83d72de8b389e08072d5b0bf465930c9.png";